import { useEffect } from 'react';

import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';
import { useAuth } from '@/_shared/hooks/useAuth';
import { groupWorkspace } from '@/_shared/lib/analytics';

/** Sync RudderStack group with current workspace. */
export function AnalyticsWorkspaceGroup(): null {
  const { user } = useAuth();
  const { slug, workspace } = useWorkspace();

  useEffect(() => {
    if (!user) return;
    groupWorkspace(workspace.id, { slug, role: workspace.role });
  }, [user, workspace.id, workspace.role, slug]);

  return null;
}
